import {postFetch} from '../api/client';

export interface RenewalQuote {
    total: number;
    totalOutput: string;
    serviceFeeOutput: string;
    baseServiceFeeOutput: string;
    baseStateFeeOutput: string;
    lateFee: number;
    lateFeeOutput: string;
    certificateFee: number;
    certificateFeeOutput: string;
    certificateTotalOutput: string;
}

export interface PreorderSchedule {
    year: string;
    opensOn: string;
    windowStart: string;
    windowEnd: string;
    window: string;
}

export interface RenewalCheckout {
    clientSecret: string;
    /** "setup": an early (pre-order) filing that saves the card without charging it; "payment": a card hold now. */
    mode: 'payment' | 'setup';
    preorder: PreorderSchedule | null;
    targetYear: string;
    authorizationText: string;
    authorizationVersion: string;
    certificateOfStatus: boolean;
    quote: RenewalQuote;
}

const pending = new Map<string, Promise<RenewalCheckout>>();

export function prepareRenewalCheckout(signature: string, reviewedCompany: any, certificateOfStatus: boolean): Promise<RenewalCheckout> {
    const body = {signature, reviewedCompany, certificateOfStatus};
    const key = JSON.stringify(body);
    const existing = pending.get(key);
    if (existing) return existing;
    const request = (async () => {
        const response = await postFetch({endpoint: `billing/${reviewedCompany.id}/payment`, authenticate: false, body});
        const result = await response.json();
        const checkout = result.message;
        if (!response.ok || !checkout?.clientSecret || !checkout?.authorizationText || !checkout?.authorizationVersion
            || !Number.isInteger(checkout.quote?.total) || checkout.quote.total <= 0
            || !checkout.quote.totalOutput || checkout.certificateOfStatus !== certificateOfStatus) {
            throw new Error(typeof checkout === 'string' ? checkout : 'Checkout could not be loaded. Please retry.');
        }
        const mode = checkout.mode === 'setup' ? 'setup' : 'payment';
        if (mode === 'setup' && !checkout.preorder?.window) {
            throw new Error('Checkout could not be loaded. Please retry.');
        }
        return {...checkout, mode, preorder: mode === 'setup' ? checkout.preorder : null} as RenewalCheckout;
    })().finally(() => pending.delete(key));
    pending.set(key, request);
    return request;
}
